import { Flex } from '@chakra-ui/react';
import { toaster, Loading } from '@shared';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSuperadminAuth } from '../context/SuperadminAuthContext';

/**
 * Only used on axios instance.
 * @returns
 */
export function SessionExpired() {
	const { clearAuthData } = useSuperadminAuth();
	const navigate = useNavigate();

	const queryParams = new URLSearchParams(location.search);
	const error = queryParams.get('error');

	useEffect(() => {
		clearAuthData();
		// Deferred: toasts created before the Toaster has started are never shown and later resurface on hover.
		setTimeout(() => toaster.create({ title: error, type: 'warning' }));
		navigate('/');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Flex justifyContent="center" alignItems="center" height="100vh">
			<Loading />
		</Flex>
	);
}
